module.exports = __webpack_public_path__ + "img/tribe-legendary.44423c26.svg";